module.exports = __webpack_public_path__ + "static/media/CinemaGrapAreasPractica.8d64f326.mp4";